'use client';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { PageSection, MoreLink } from '@/components';
import { useStaggerIn } from '@/hooks/useStaggerIn';
import { ClientGrid } from '@/views/clientes/ClientesSection';
import { clientGroups } from '@/libs/content/clients';
import { copy } from '@/libs/content/copy';

// Grilla de la home: solo el grupo "Empresas" (como el prototipo, ~18 nombres).
const empresas = clientGroups.find((g) => g.id === 'empresas')?.clients ?? [];

export default function ExperienciaTeaser() {
  const ref = useStaggerIn({ stagger: 0.04 });
  const { teaser } = copy.experiencia;

  return (
    <PageSection
      id="experiencia"
      tone="navy"
      align="center"
      eyebrow={teaser.eyebrow}
      title={teaser.heading}
    >
      <Box ref={ref}>
        <ClientGrid clients={empresas} cols={4} />
      </Box>
      <Typography
        sx={{
          textAlign: 'center',
          fontSize: '13px',
          color: 'text.onDarkFaint',
          mt: '20px',
        }}
      >
        {copy.clientes.note}
      </Typography>
      <Box sx={{ textAlign: 'center', mt: { xs: 4, md: 6 } }}>
        <MoreLink href="/experiencia/" tone="dark">
          {copy.home.more.experiencia}
        </MoreLink>
      </Box>
    </PageSection>
  );
}
